import { useEffect, useState } from "react";
import { fetchMediaArticles } from "../../api/wp";

// LEAPS AI Media（WordPress の CPT media）の新着3本。
// 新着をそのまま並べるとカテゴリが偏るので、カテゴリ違いを優先して3本選ぶ（旧トップと同じ選び方）。

const FALLBACK = [
  {
    key: "dpp-apparel-deadline",
    link: "https://leaps-inc.com/media/dpp-apparel-deadline/",
    image:
      "https://leaps-inc.com/cms-admin/wp-content/uploads/2026/09/dpp-apparel-deadline-768x432.png",
    date: "2026-09-30",
    tag: "EU規制",
    title: "「DPPは2029年から」ではありません ― 欧州向けアパレルの実際の期限",
    excerpt:
      "EUのデジタル製品パスポート（DPP）は繊維製品で2029年ごろの適用見込みですが、生産計画から逆算すると準備開始は2027年。先に始まる強制労働規則・繊維EPRとあわせて、実際の期限を整理します。",
  },
  {
    key: "ai-case-studies",
    link: "https://leaps-inc.com/media/ai-case-studies/",
    image:
      "https://leaps-inc.com/cms-admin/wp-content/uploads/2026/09/ai-case-studies-768x432.png",
    date: "2026-09-28",
    tag: "業務別活用",
    title: "国内外34のAI活用事例を業務別に整理｜効果が出た仕事の共通点",
    excerpt:
      "国内外のAI導入事例34件を、会社の発表や国の資料までさかのぼって集めました。自社のどの仕事に使えるかを探せる業務別の早見表と、従業員30〜100名ほどの中小企業が実際に何をしたか、最初の一歩の試し方をまとめます。",
  },
  {
    key: "ai-budget-approval",
    link: "https://leaps-inc.com/media/ai-budget-approval/",
    image:
      "https://leaps-inc.com/cms-admin/wp-content/uploads/2026/09/ai-budget-approval-768x432.png",
    date: "2026-09-01",
    tag: "費用・ベンダー選定",
    title: "AI導入の稟議を通すために用意した資料の中身",
    excerpt:
      "「効果が読めない」で止まる稟議に対して、実際に通った資料がどう構成されていたかを公開します。",
  },
];

const strip = (html = "") =>
  html
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&#8230;|&hellip;/g, "…")
    .replace(/&amp;/g, "&")
    .trim();

function toItem(post) {
  const cat = post._embedded?.["wp:term"]
    ?.flat?.()
    ?.find((t) => t?.taxonomy === "media_category");
  const media = post._embedded?.["wp:featuredmedia"]?.[0];
  return {
    key: String(post.id),
    link: post.link,
    image:
      media?.media_details?.sizes?.medium_large?.source_url ||
      media?.source_url ||
      null,
    date: (post.date || "").slice(0, 10),
    tag: cat?.name || "",
    title: strip(post.title?.rendered),
    excerpt: strip(post.excerpt?.rendered),
  };
}

function pickVaried(list) {
  const picked = [];
  const used = new Set();
  for (const post of list) {
    const cat = post._embedded?.["wp:term"]
      ?.flat?.()
      ?.find((t) => t?.taxonomy === "media_category");
    const key = cat?.id ?? `no-cat-${post.id}`;
    if (used.has(key)) continue;
    used.add(key);
    picked.push(post);
    if (picked.length === 3) return picked;
  }
  for (const post of list) {
    if (!picked.includes(post)) picked.push(post);
    if (picked.length === 3) break;
  }
  return picked;
}

export default function HomeMedia() {
  const [items, setItems] = useState(FALLBACK);

  useEffect(() => {
    let alive = true;
    fetchMediaArticles({ per_page: 12, _embed: 1 })
      .then((list) => {
        if (alive && list?.length) setItems(pickVaried(list).map(toItem));
      })
      .catch((err) => console.error("[HomeMedia] fetch error:", err));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <section className="section ground media">
      <div className="container">
        <h2 className="home-h2">
          <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
          メディア・記事<strong>Media &amp; Article</strong>
        </h2>
        <div className="media-grid">
          {items.map((a) => (
            <a className="media-card" href={a.link} key={a.key}>
              {a.image && (
                <img
                  className="media-thumb"
                  src={a.image}
                  alt={a.title}
                  loading="lazy"
                />
              )}
              <div className="media-body">
                <div className="media-meta">
                  <time className="date" dateTime={a.date}>
                    {a.date.replaceAll("-", ".")}
                  </time>
                  {a.tag && <span className="media-tag">{a.tag}</span>}
                </div>
                <h3>{a.title}</h3>
                {a.excerpt && <p>{a.excerpt}</p>}
              </div>
            </a>
          ))}
        </div>
        <div className="more">
          <a href="https://leaps-inc.com/media/">
            LEAPS AI Media の記事をすべて見る →
          </a>
        </div>
      </div>
    </section>
  );
}
